(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/widgets-campaign/assets/javascripts/frames/valentines2024/valentines.js') >= 0) return;  svs.modules.push('/modules/widgets-campaign/assets/javascripts/frames/valentines2024/valentines.js');
"use strict";


const _React = React,
  Fragment = _React.Fragment;
const valentines2024Path = "".concat(svs.core.config.data.svsconfig.cdn, "/images/widgets-campaign/valentines2024");
const BottomFrame = () => React.createElement("div", {
  className: "valentines-bottom-frame row pointer-none"
}, React.createElement("div", {
  className: "valentines-bottom-layers relative col-md-12"
}, React.createElement("img", {
  alt: "alla hj\xE4rtans dag-ram",
  className: "bottom-frame-valentines",
  src: "".concat(valentines2024Path, "/valentines-bottom-frame.png")
})));
const TopFrame = () => React.createElement("div", {
  className: "valentines-top-frame row"
}, React.createElement("div", {
  className: "valentines-top-frame-container relative col-md-12"
}));
const Valentines = _ref => {
  let children = _ref.children,
    _ref$showTop = _ref.showTop,
    showTop = _ref$showTop === void 0 ? true : _ref$showTop,
    _ref$showBottom = _ref.showBottom,
    showBottom = _ref$showBottom === void 0 ? true : _ref$showBottom;
  return React.createElement(Fragment, null, showTop && React.createElement(TopFrame, null), children, showBottom && React.createElement(BottomFrame, null));
};
setGlobal('svs.widgetsCampaign.frames.valentines2024.Valentines', Valentines);

 })(window);